import React, {useEffect} from "react"
import IconX from "../../iconComponents/IconX";
import IconArrowBack from "../../iconComponents/IconArrowBack";
import { Logo } from "../../../brand";

export default function Modal(props) {

    const handleBack = () => {
        props.handleBack();
    }
    const handleClose = () => {
        props.handleClose();
    }
    const escape = (e) => {
        e.keyCode === 27 && props.handleClose();
    }
    // when modal opens, start listening for "escape" key (which closes the modal)
    useEffect(() => {
        window.addEventListener('keyup', escape);
        return () => {
            window.removeEventListener('keyup', escape);
        }
    }, [])


    return (
        <div className={(props.blurBack ? "modal-wrap blurback ": "modal-wrap ") + (props.className && props.className)} onClick={(e) => props.hasCloseButton && props.handleClose(e)} >
            <div className={props.className ? props.className + " modal" : "modal"} onClick={(e) => e.stopPropagation()} >
                <div className="flex-row" style={{justifyContent: "space-between", width: "100%"}} >
                    <div style={{margin: "-24px 0 0 -24px", padding: "3px"}}>
                        {props.hasBackButton && 
                        <button onClick={() => handleBack()} >
                            <IconArrowBack pathClass="g6-fill" height="16px" />
                        </button>}
                    </div>
                    <div style={{margin: "-24px -24px 0 0", padding: "3px"}}>
                        {props.hasCloseButton && 
                        <button onClick={(e) => handleClose(e)} onKeyUp={(e) => console.log("testing for key up")} >
                            <IconX pathClass="g6-fill" height="16px" />
                        </button>}
                    </div>
                </div>
                {!props.hideLogo && <Logo height="34px" className="modal-logo gap-below-m" />}
                {props.slogan && <h6 className="slogan g5-text gap-below-m">A new standard of trust and transparency in document exchange</h6>}
                <div className="w100" style={{whiteSpace: "pre-wrap"}} >
                    {props.children}
                </div>              
            </div>
        </div>
    )
}
